import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backendUrl}/analytics`;
  // This is a placeholder for Google Analytics or Meta Pixel
  // In a real scenario, you would use window['gtag'] or similar
  
  logEvent(eventName: string, params: any = {}) {
    // console.log(`[Analytics] Event: ${eventName}`, params);
    const referralSource = typeof window !== 'undefined' ? sessionStorage.getItem('referral_source') : null;
    
     this.http.post(`${this.apiUrl}/events`, {
       eventName,
       params: { 
         ...params, 
         referral_source: referralSource,
         page_id: window.location.pathname
       },
       timestamp: new Date().toISOString(),
       url: window.location.href
     }).subscribe({
        error: err => console.error('Analytics error', err)
     });
  }

  logPageView(url: string) {
    console.log(`[Analytics] PageView: ${url}`);
    // if (typeof window !== 'undefined' && (window as any).gtag) {
    //   (window as any).gtag('config', 'G-XXXXXXXXXX', { page_path: url });
    // }
  }

  trackProductView(product: any) {
    this.logEvent('view_item', {
      items: [{
        item_id: product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price
      }]
    });
  }

  trackAddToCart(product: any, quantity: number) {
    this.logEvent('add_to_cart', {
      items: [{
        item_id: product.id,
        item_name: product.name,
        price: product.price,
        quantity: quantity
      }]
    });
  }

  trackPurchase(orderId: string, total: number, items: any[]) {
    this.logEvent('purchase', {
      transaction_id: orderId,
      value: total,
      currency: 'INR',
      items: items.map(i => ({
        item_id: i.productId,
        item_name: i.originalProduct.name,
        price: i.discountedPrice || i.price,
        quantity: i.quantity
      }))
    });
  }

  trackReferral(source: string) {
    if (!source) return;
    
    // Store in sessionStorage to persist for the session
    if (typeof window !== 'undefined') {
      const existingSource = sessionStorage.getItem('referral_source');
      if (existingSource !== source) {
        sessionStorage.setItem('referral_source', source);
        this.logEvent('referral_visit', { source });
      }
    }
  }
}
